/**
 * Patient Model
 */

 export interface DrawerModel {
     visible?: boolean;
 }